import type { TableRef } from '../engine/ProblemSource';

import type { VifTileDataset } from './vifAddSubData';

export const MUL_POOL1: string[] = [
  '2 × 2',
  '2 × 3',
  '2 × 4',
  '2 × 5',
  '2 × 6',
  '2 × 7',
  '2 × 8',
  '2 × 9',
  '3 × 3',
  '3 × 4',
  '3 × 5',
  '3 × 6',
  '3 × 7',
  '3 × 8',
  '3 × 9',
  '4 × 4',
  '4 × 5',
  '4 × 6',
  '4 × 7',
  '4 × 8',
  '4 × 9',
  '5 × 5',
  '5 × 6',
  '5 × 7',
  '5 × 8',
  '5 × 9',
  '6 × 6',
  '6 × 7',
  '6 × 8',
  '6 × 9',
  '7 × 7',
  '7 × 8',
  '7 × 9',
  '8 × 8',
  '8 × 9',
  '9 × 9',
];

export const MUL_POOL1_ANSW: string[] = [
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '9',
  '12',
  '15',
  '18',
  '21',
  '24',
  '27',
  '16',
  '20',
  '24',
  '28',
  '32',
  '36',
  '25',
  '30',
  '35',
  '40',
  '45',
  '36',
  '42',
  '48',
  '54',
  '49',
  '56',
  '63',
  '64',
  '72',
  '81',
];

export const MUL_POOL2: string[] = [
  '3 × 2',
  '4 × 2',
  '5 × 2',
  '6 × 2',
  '7 × 2',
  '8 × 2',
  '9 × 2',
  '4 × 3',
  '5 × 3',
  '6 × 3',
  '7 × 3',
  '8 × 3',
  '9 × 3',
  '5 × 4',
  '6 × 4',
  '7 × 4',
  '8 × 4',
  '9 × 4',
  '6 × 5',
  '7 × 5',
  '8 × 5',
  '9 × 5',
  '7 × 6',
  '8 × 6',
  '9 × 6',
  '8 × 7',
  '9 × 7',
  '9 × 8',
];

export const MUL_POOL2_ANSW: string[] = [
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '12',
  '15',
  '18',
  '21',
  '24',
  '27',
  '20',
  '24',
  '28',
  '32',
  '36',
  '30',
  '35',
  '40',
  '45',
  '42',
  '48',
  '54',
  '56',
  '63',
  '72',
];

export const DIV_POOL1: string[] = [
  '4 ÷ 2',
  '6 ÷ 2',
  '8 ÷ 2',
  '10 ÷ 2',
  '12 ÷ 2',
  '14 ÷ 2',
  '16 ÷ 2',
  '18 ÷ 2',
  '9 ÷ 3',
  '12 ÷ 3',
  '15 ÷ 3',
  '18 ÷ 3',
  '21 ÷ 3',
  '24 ÷ 3',
  '27 ÷ 3',
  '16 ÷ 4',
  '20 ÷ 4',
  '24 ÷ 4',
  '28 ÷ 4',
  '32 ÷ 4',
  '36 ÷ 4',
  '25 ÷ 5',
  '30 ÷ 5',
  '35 ÷ 5',
  '40 ÷ 5',
  '45 ÷ 5',
  '36 ÷ 6',
  '42 ÷ 6',
  '48 ÷ 6',
  '54 ÷ 6',
  '49 ÷ 7',
  '56 ÷ 7',
  '63 ÷ 7',
  '64 ÷ 8',
  '72 ÷ 8',
  '81 ÷ 9',
];

export const DIV_POOL1_ANSW: string[] = [
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '5',
  '6',
  '7',
  '8',
  '9',
  '6',
  '7',
  '8',
  '9',
  '7',
  '8',
  '9',
  '8',
  '9',
  '9',
];

export const DIV_POOL2: string[] = [
  '6 ÷ 3',
  '8 ÷ 4',
  '10 ÷ 5',
  '12 ÷ 6',
  '14 ÷ 7',
  '16 ÷ 8',
  '18 ÷ 9',
  '12 ÷ 4',
  '15 ÷ 5',
  '18 ÷ 6',
  '21 ÷ 7',
  '24 ÷ 8',
  '27 ÷ 9',
  '20 ÷ 5',
  '24 ÷ 6',
  '28 ÷ 7',
  '32 ÷ 8',
  '36 ÷ 9',
  '30 ÷ 6',
  '35 ÷ 7',
  '40 ÷ 8',
  '45 ÷ 9',
  '42 ÷ 7',
  '48 ÷ 8',
  '54 ÷ 9',
  '56 ÷ 8',
  '63 ÷ 9',
  '72 ÷ 9',
];

export const DIV_POOL2_ANSW: string[] = [
  '2',
  '2',
  '2',
  '2',
  '2',
  '2',
  '2',
  '3',
  '3',
  '3',
  '3',
  '3',
  '3',
  '4',
  '4',
  '4',
  '4',
  '4',
  '5',
  '5',
  '5',
  '5',
  '5',
  '6',
  '6',
  '6',
  '7',
  '7',
  '8',
];

export const DIV_START_SECONDS: number[] = [0, 70, 60, 45];

/** The 36-entry times-table pool used to fill MUL/DIV round 3's extra 9 tiles. */
export const ROUND3_MUL_POOL: readonly string[] = [
  '2 × 2',
  '2 × 3',
  '2 × 4',
  '2 × 5',
  '2 × 6',
  '2 × 7',
  '2 × 8',
  '2 × 9',
  '3 × 3',
  '3 × 4',
  '3 × 5',
  '3 × 6',
  '3 × 7',
  '3 × 8',
  '3 × 9',
  '4 × 4',
  '4 × 5',
  '4 × 6',
  '4 × 7',
  '4 × 8',
  '4 × 9',
  '5 × 5',
  '5 × 6',
  '5 × 7',
  '5 × 8',
  '5 × 9',
  '6 × 6',
  '6 × 7',
  '6 × 8',
  '6 × 9',
  '7 × 7',
  '7 × 8',
  '7 × 9',
  '8 × 8',
  '8 × 9',
  '9 × 9',
];

export const ROUND3_MUL_POOL_ANSW: readonly string[] = [
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '9',
  '12',
  '15',
  '18',
  '21',
  '24',
  '27',
  '16',
  '20',
  '24',
  '28',
  '32',
  '36',
  '25',
  '30',
  '35',
  '40',
  '45',
  '36',
  '42',
  '48',
  '54',
  '49',
  '56',
  '63',
  '64',
  '72',
  '81',
];

export const ROUND3_DIV_POOL: readonly string[] = [
  '4 ÷ 2',
  '6 ÷ 2',
  '8 ÷ 2',
  '10 ÷ 2',
  '12 ÷ 2',
  '14 ÷ 2',
  '16 ÷ 2',
  '18 ÷ 2',
  '9 ÷ 3',
  '12 ÷ 3',
  '15 ÷ 3',
  '18 ÷ 3',
  '21 ÷ 3',
  '24 ÷ 3',
  '27 ÷ 3',
  '16 ÷ 4',
  '20 ÷ 4',
  '24 ÷ 4',
  '28 ÷ 4',
  '32 ÷ 4',
  '36 ÷ 4',
  '25 ÷ 5',
  '30 ÷ 5',
  '35 ÷ 5',
  '40 ÷ 5',
  '45 ÷ 5',
  '36 ÷ 6',
  '42 ÷ 6',
  '48 ÷ 6',
  '54 ÷ 6',
  '49 ÷ 7',
  '56 ÷ 7',
  '63 ÷ 7',
  '64 ÷ 8',
  '72 ÷ 8',
  '81 ÷ 9',
];

export const ROUND3_DIV_POOL_ANSW: readonly string[] = [
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '5',
  '6',
  '7',
  '8',
  '9',
  '6',
  '7',
  '8',
  '9',
  '7',
  '8',
  '9',
  '8',
  '9',
  '9',
];

const mulRound1Layer1: VifTileDataset = {
  topEQs: [
    '2 × 2',
    '2 × 3',
    '2 × 4',
    '2 × 5',
    '2 × 6',
    '2 × 7',
    '2 × 8',
    '2 × 9',
    '3 × 3',
    '3 × 4',
    '3 × 5',
    '3 × 6',
    '3 × 7',
    '3 × 8',
    '3 × 9',
    '4 × 4',
  ],
  bottomAnswers: [
    '4',
    '6',
    '8',
    '10',
    '12',
    '14',
    '16',
    '18',
    '9',
    '12',
    '15',
    '18',
    '21',
    '24',
    '27',
    '16',
  ],
  tEqValues: [
    '4',
    '6',
    '8',
    '10',
    '12',
    '14',
    '16',
    '18',
    '9',
    '12',
    '15',
    '18',
    '21',
    '24',
    '27',
    '16',
  ],
};

const mulRound1Layer2: VifTileDataset = {
  topEQs: [
    '4 × 5',
    '4 × 6',
    '4 × 7',
    '4 × 8',
    '4 × 9',
    '5 × 5',
    '5 × 6',
    '5 × 7',
    '5 × 8',
    '5 × 9',
    '6 × 6',
    '6 × 7',
    '6 × 8',
    '6 × 9',
    '7 × 7',
    '7 × 8',
  ],
  bottomAnswers: [
    '20',
    '24',
    '28',
    '32',
    '36',
    '25',
    '30',
    '35',
    '40',
    '45',
    '36',
    '42',
    '48',
    '54',
    '49',
    '56',
  ],
  tEqValues: [
    '20',
    '24',
    '28',
    '32',
    '36',
    '25',
    '30',
    '35',
    '40',
    '45',
    '36',
    '42',
    '48',
    '54',
    '49',
    '56',
  ],
};

const mulRound1Layer3: VifTileDataset = {
  topEQs: [
    '3 × 2',
    '4 × 2',
    '5 × 2',
    '6 × 2',
    '7 × 2',
    '8 × 2',
    '9 × 2',
    '4 × 3',
    '5 × 3',
    '6 × 3',
    '7 × 3',
    '8 × 3',
    '7 × 9',
    '8 × 8',
    '8 × 9',
    '9 × 9',
  ],
  bottomAnswers: [
    '6',
    '8',
    '10',
    '12',
    '14',
    '16',
    '18',
    '12',
    '15',
    '18',
    '21',
    '24',
    '63',
    '64',
    '72',
    '81',
  ],
  tEqValues: [
    '6',
    '8',
    '10',
    '12',
    '14',
    '16',
    '18',
    '12',
    '15',
    '18',
    '21',
    '24',
    '63',
    '64',
    '72',
    '81',
  ],
};

const mulRound1Layer4: VifTileDataset = {
  topEQs: [
    '9 × 3',
    '5 × 4',
    '6 × 4',
    '7 × 4',
    '8 × 4',
    '9 × 4',
    '6 × 5',
    '7 × 5',
    '8 × 5',
    '9 × 5',
    '7 × 6',
    '8 × 6',
    '9 × 6',
    '8 × 7',
    '9 × 7',
    '9 × 8',
  ],
  bottomAnswers: [
    '27',
    '20',
    '24',
    '28',
    '32',
    '36',
    '30',
    '35',
    '40',
    '45',
    '42',
    '48',
    '54',
    '56',
    '63',
    '72',
  ],
  tEqValues: [
    '27',
    '20',
    '24',
    '28',
    '32',
    '36',
    '30',
    '35',
    '40',
    '45',
    '42',
    '48',
    '54',
    '56',
    '63',
    '72',
  ],
};

const mulRound2Layer1: VifTileDataset = {
  topEQs: [
    '2 × 7',
    '4 × 6',
    '8 × 7',
    '2 × 3',
    '0 × 5',
    '4 × 4',
    '3 × 4',
    '5 × 2',
    '7 × 3',
    '1 × 1',
    '3 × 6',
    '2 × 2',
    '6 × 2',
    '7 × 9',
    '9 × 3',
    '6 × 9',
  ],
  bottomAnswers: [
    '14',
    '24',
    '56',
    '6',
    '0',
    '16',
    '12',
    '10',
    '21',
    '1',
    '18',
    '4',
    '12',
    '63',
    '27',
    '54',
  ],
  tEqValues: [
    '14',
    '24',
    '56',
    '6',
    '0',
    '16',
    '12',
    '10',
    '21',
    '1',
    '18',
    '4',
    '12',
    '63',
    '27',
    '54',
  ],
};

const mulRound2Layer2: VifTileDataset = {
  topEQs: [
    '6 × 4',
    '3 × 2',
    '5 × 3',
    '0 × 1',
    '3 × 3',
    '8 × 4',
    '7 × 5',
    '2 × 8',
    '4 × 9',
    '5 × 1',
    '5 × 8',
    '8 × 8',
    '3 × 8',
    '9 × 5',
    '6 × 5',
    '4 × 7',
  ],
  bottomAnswers: [
    '24',
    '6',
    '15',
    '0',
    '9',
    '32',
    '35',
    '16',
    '36',
    '5',
    '40',
    '64',
    '24',
    '45',
    '30',
    '28',
  ],
  tEqValues: [
    '24',
    '6',
    '15',
    '0',
    '9',
    '32',
    '35',
    '16',
    '36',
    '5',
    '40',
    '64',
    '24',
    '45',
    '30',
    '28',
  ],
};

const mulRound2Layer3: VifTileDataset = {
  topEQs: [
    '7 × 2',
    '6 × 6',
    '0 × 9',
    '4 × 2',
    '4 × 8',
    '5 × 7',
    '8 × 6',
    '2 × 5',
    '9 × 4',
    '1 × 4',
    '6 × 3',
    '7 × 7',
    '2 × 6',
    '9 × 7',
    '5 × 6',
    '8 × 9',
  ],
  bottomAnswers: [
    '14',
    '36',
    '0',
    '8',
    '32',
    '35',
    '48',
    '10',
    '36',
    '4',
    '18',
    '49',
    '12',
    '63',
    '30',
    '72',
  ],
  tEqValues: [
    '14',
    '36',
    '0',
    '8',
    '32',
    '35',
    '48',
    '10',
    '36',
    '4',
    '18',
    '49',
    '12',
    '63',
    '30',
    '72',
  ],
};

const mulRound2Layer4: VifTileDataset = {
  topEQs: [
    '7 × 8',
    '3 × 5',
    '6 × 0',
    '2 × 4',
    '5 × 5',
    '4 × 3',
    '6 × 8',
    '8 × 2',
    '3 × 7',
    '1 × 6',
    '8 × 5',
    '9 × 9',
    '8 × 3',
    '5 × 9',
    '3 × 9',
    '6 × 7',
  ],
  bottomAnswers: [
    '56',
    '15',
    '0',
    '8',
    '25',
    '12',
    '48',
    '16',
    '21',
    '6',
    '40',
    '81',
    '24',
    '45',
    '27',
    '42',
  ],
  tEqValues: [
    '56',
    '15',
    '0',
    '8',
    '25',
    '12',
    '48',
    '16',
    '21',
    '6',
    '40',
    '81',
    '24',
    '45',
    '27',
    '42',
  ],
};

const mulRound3Layer1: VifTileDataset = {
  topEQs: ['2 × 9', '7 × 4', '0 × 0', '3 × 1', '4 × 3', '8 × 5', '9 × 7'],
  bottomAnswers: ['18', '28', '0', '3', '12', '40', '63'],
  tEqValues: ['18', '28', '0', '3', '12', '40', '63'],
};

const mulRound3Layer2: VifTileDataset = {
  topEQs: ['4 × 5', '7 × 6', '0 × 7', '1 × 8', '7 × 3', '8 × 4', '7 × 6'],
  bottomAnswers: ['20', '42', '0', '8', '21', '32', '42'],
  tEqValues: ['20', '42', '0', '8', '21', '32', '42'],
};

const mulRound3Layer3: VifTileDataset = {
  topEQs: ['9 × 2', '9 × 6', '2 × 0', '7 × 1', '8 × 2', '9 × 3', '9 × 6'],
  bottomAnswers: ['18', '54', '0', '7', '16', '27', '54'],
  tEqValues: ['18', '54', '0', '7', '16', '27', '54'],
};

const mulRound3Layer4: VifTileDataset = {
  topEQs: ['5 × 4', '9 × 8', '0 × 3', '9 × 1', '6 × 3', '7 × 4', '8 × 7'],
  bottomAnswers: ['20', '72', '0', '9', '18', '28', '56'],
  tEqValues: ['20', '72', '0', '9', '18', '28', '56'],
};

const divRound1Layer1 = {
  topEQs: [
    '4 ÷ 2',
    '6 ÷ 2',
    '8 ÷ 2',
    '10 ÷ 2',
    '12 ÷ 2',
    '14 ÷ 2',
    '16 ÷ 2',
    '18 ÷ 2',
    '6 ÷ 3',
    '9 ÷ 3',
    '12 ÷ 3',
    '15 ÷ 3',
    '18 ÷ 3',
    '21 ÷ 3',
    '24 ÷ 3',
    '27 ÷ 3',
  ],
  bottomAnswers: [
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ],
};

const divRound1Layer2 = {
  topEQs: [
    '8 ÷ 4',
    '12 ÷ 4',
    '16 ÷ 4',
    '20 ÷ 4',
    '24 ÷ 4',
    '28 ÷ 4',
    '32 ÷ 4',
    '36 ÷ 4',
    '10 ÷ 5',
    '15 ÷ 5',
    '20 ÷ 5',
    '25 ÷ 5',
    '30 ÷ 5',
    '35 ÷ 5',
    '40 ÷ 5',
    '45 ÷ 5',
  ],
  bottomAnswers: [
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ],
};

const divRound1Layer3 = {
  topEQs: [
    '12 ÷ 6',
    '18 ÷ 6',
    '24 ÷ 6',
    '30 ÷ 6',
    '36 ÷ 6',
    '42 ÷ 6',
    '48 ÷ 6',
    '54 ÷ 6',
    '14 ÷ 7',
    '21 ÷ 7',
    '28 ÷ 7',
    '35 ÷ 7',
    '42 ÷ 7',
    '49 ÷ 7',
    '56 ÷ 7',
    '63 ÷ 7',
  ],
  bottomAnswers: [
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ],
};

const divRound1Layer4 = {
  topEQs: [
    '16 ÷ 8',
    '24 ÷ 8',
    '32 ÷ 8',
    '40 ÷ 8',
    '48 ÷ 8',
    '56 ÷ 8',
    '64 ÷ 8',
    '72 ÷ 8',
    '18 ÷ 9',
    '27 ÷ 9',
    '36 ÷ 9',
    '45 ÷ 9',
    '54 ÷ 9',
    '63 ÷ 9',
    '72 ÷ 9',
    '81 ÷ 9',
  ],
  bottomAnswers: [
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ],
};

const divRound2Layer1 = {
  topEQs: [
    '12 ÷ 4',
    '24 ÷ 3',
    '56 ÷ 8',
    '6 ÷ 2',
    '0 ÷ 5',
    '16 ÷ 4',
    '12 ÷ 3',
    '10 ÷ 2',
    '25 ÷ 5',
    '1 ÷ 1',
    '16 ÷ 2',
    '4 ÷ 2',
    '12 ÷ 2',
    '63 ÷ 9',
    '27 ÷ 3',
    '54 ÷ 9',
  ],
  bottomAnswers: [
    '3',
    '8',
    '7',
    '3',
    '0',
    '4',
    '4',
    '5',
    '5',
    '1',
    '8',
    '2',
    '6',
    '7',
    '9',
    '6',
  ],
};

const divRound2Layer2 = {
  topEQs: [
    '24 ÷ 8',
    '6 ÷ 3',
    '15 ÷ 5',
    '54 ÷ 6',
    '20 ÷ 5',
    '32 ÷ 4',
    '35 ÷ 5',
    '8 ÷ 2',
    '14 ÷ 7',
    '5 ÷ 1',
    '40 ÷ 8',
    '64 ÷ 8',
    '24 ÷ 4',
    '45 ÷ 5',
    '30 ÷ 5',
    '28 ÷ 4',
  ],
  bottomAnswers: [
    '3',
    '2',
    '3',
    '9',
    '4',
    '8',
    '7',
    '4',
    '2',
    '5',
    '5',
    '8',
    '6',
    '9',
    '6',
    '7',
  ],
};

const divRound2Layer3 = {
  topEQs: [
    '14 ÷ 2',
    '36 ÷ 6',
    '72 ÷ 8',
    '18 ÷ 3',
    '32 ÷ 8',
    '35 ÷ 7',
    '48 ÷ 6',
    '10 ÷ 5',
    '36 ÷ 9',
    '3 ÷ 1',
    '18 ÷ 6',
    '49 ÷ 7',
    '12 ÷ 6',
    '63 ÷ 7',
    '30 ÷ 6',
    '72 ÷ 9',
  ],
  bottomAnswers: [
    '7',
    '6',
    '9',
    '6',
    '4',
    '5',
    '8',
    '2',
    '4',
    '3',
    '3',
    '7',
    '2',
    '9',
    '5',
    '8',
  ],
};

const divRound2Layer4 = {
  topEQs: [
    '56 ÷ 7',
    '15 ÷ 3',
    '0 ÷ 6',
    '8 ÷ 4',
    '21 ÷ 3',
    '36 ÷ 4',
    '48 ÷ 8',
    '16 ÷ 8',
    '21 ÷ 7',
    '6 ÷ 1',
    '40 ÷ 5',
    '81 ÷ 9',
    '24 ÷ 6',
    '45 ÷ 9',
    '27 ÷ 9',
    '42 ÷ 6',
  ],
  bottomAnswers: [
    '8',
    '5',
    '0',
    '2',
    '7',
    '9',
    '6',
    '2',
    '3',
    '6',
    '8',
    '9',
    '4',
    '5',
    '3',
    '7',
  ],
};

const divRound3Layer1 = {
  topEQs: ['18 ÷ 9', '28 ÷ 7', '0 ÷ 5', '3 ÷ 1', '12 ÷ 4', '40 ÷ 8', '63 ÷ 9'],
  bottomAnswers: ['2', '4', '0', '3', '3', '5', '7'],
};

const divRound3Layer2 = {
  topEQs: ['20 ÷ 5', '42 ÷ 7', '0 ÷ 7', '9 ÷ 1', '21 ÷ 7', '32 ÷ 8', '14 ÷ 7'],
  bottomAnswers: ['4', '6', '0', '9', '3', '4', '2'],
};

const divRound3Layer3 = {
  topEQs: ['30 ÷ 6', '54 ÷ 9', '0 ÷ 3', '7 ÷ 1', '16 ÷ 8', '27 ÷ 9', '45 ÷ 9'],
  bottomAnswers: ['5', '6', '0', '7', '2', '3', '5'],
};

const divRound3Layer4 = {
  topEQs: ['36 ÷ 9', '72 ÷ 9', '0 ÷ 7', '4 ÷ 1', '18 ÷ 6', '48 ÷ 8', '56 ÷ 8'],
  bottomAnswers: ['4', '8', '0', '4', '3', '6', '7'],
};

const fallbackLayer1: VifTileDataset = {
  topEQs: [
    '4 - 2',
    '5 - 2',
    '6 - 3',
    '6 - 2',
    '7 - 3',
    '8 - 4',
    '7 - 2',
    '8 - 3',
    '9 - 4',
    '10 - 5',
    '8 - 2',
    '9 - 3',
    '10 - 4',
    '9 - 2',
    '10 - 3',
    '10 - 2',
  ],
  bottomAnswers: [
    '2',
    '3',
    '3',
    '4',
    '4',
    '4',
    '5',
    '5',
    '5',
    '5',
    '6',
    '6',
    '6',
    '7',
    '7',
    '8',
  ],
  tEqValues: [
    '2',
    '3',
    '3',
    '4',
    '4',
    '4',
    '5',
    '5',
    '5',
    '5',
    '6',
    '6',
    '6',
    '7',
    '7',
    '8',
  ],
};

// NOTE: bottomAnswers and tEqValues intentionally differ in this dataset (verbatim from source).
const fallbackPatternGroupA: VifTileDataset = {
  topEQs: [
    '0 - 0',
    '3 - 3',
    '6 - 6',
    '9 - 9',
    '2 - 1',
    '7 - 6',
    '8 - 7',
    '2 - 0',
    '5 - 3',
    '7 - 5',
    '4 - 1',
    '8 - 5',
    '10 - 6',
    '6 - 0',
    '8 - 1',
    '9 - 0',
  ],
  bottomAnswers: [
    '0',
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '2',
    '2',
    '2',
    '3',
    '3',
    '4',
    '6',
    '7',
    '9',
  ],
  tEqValues: [
    '10',
    '10',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '5',
    '5',
    '5',
    '3',
    '3',
    '2',
    '1',
  ],
};

const fallbackPatternGroupB: VifTileDataset = {
  topEQs: [
    '1 - 1',
    '4 - 4',
    '7 - 7',
    '3 - 2',
    '5 - 4',
    '6 - 5',
    '10 - 9',
    '8 - 6',
    '9 - 7',
    '7 - 4',
    '10 - 7',
    '4 - 0',
    '9 - 5',
    '5 - 0',
    '7 - 1',
    '9 - 1',
  ],
  bottomAnswers: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '1',
    '2',
    '2',
    '3',
    '3',
    '4',
    '4',
    '5',
    '6',
    '8',
  ],
  tEqValues: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '1',
    '2',
    '2',
    '3',
    '3',
    '4',
    '4',
    '5',
    '6',
    '8',
  ],
};

const fallbackPatternGroupC: VifTileDataset = {
  topEQs: [
    '2 - 2',
    '5 - 5',
    '8 - 8',
    '1 - 0',
    '4 - 3',
    '9 - 8',
    '3 - 1',
    '6 - 4',
    '10 - 8',
    '3 - 0',
    '9 - 6',
    '5 - 1',
    '6 - 1',
    '7 - 0',
    '8 - 0',
    '10 - 1',
  ],
  bottomAnswers: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '2',
    '2',
    '2',
    '3',
    '3',
    '4',
    '5',
    '7',
    '8',
    '9',
  ],
  tEqValues: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '2',
    '2',
    '2',
    '3',
    '3',
    '4',
    '5',
    '7',
    '8',
    '9',
  ],
};

export const VIF_MUL_DIV_DATA = {
  mul: {
    round1: {
      layer1: mulRound1Layer1,
      layer2: mulRound1Layer2,
      layer3: mulRound1Layer3,
      layer4: mulRound1Layer4,
    },
    round2: {
      layer1: mulRound2Layer1,
      layer2: mulRound2Layer2,
      layer3: mulRound2Layer3,
      layer4: mulRound2Layer4,
    },
    round3: {
      layer1: mulRound3Layer1,
      layer2: mulRound3Layer2,
      layer3: mulRound3Layer3,
      layer4: mulRound3Layer4,
    },
  },
  div: {
    round1: {
      layer1: divRound1Layer1,
      layer2: divRound1Layer2,
      layer3: divRound1Layer3,
      layer4: divRound1Layer4,
    },
    round2: {
      layer1: divRound2Layer1,
      layer2: divRound2Layer2,
      layer3: divRound2Layer3,
      layer4: divRound2Layer4,
    },
    round3: {
      layer1: divRound3Layer1,
      layer2: divRound3Layer2,
      layer3: divRound3Layer3,
      layer4: divRound3Layer4,
    },
  },
  fallback: {
    layer1: fallbackLayer1,
    patternGroupA: fallbackPatternGroupA,
    patternGroupB: fallbackPatternGroupB,
    patternGroupC: fallbackPatternGroupC,
  },
};

/** (operation, round, layer) -> the fixed base-table dataset for MUL/DIV rounds 1-3. */
export function mulDivTableRef(
  op: 'mul' | 'div',
  round: number,
  layer: number,
): TableRef {
  const tree = VIF_MUL_DIV_DATA[op];
  const roundData =
    round === 1 ? tree.round1 : round === 2 ? tree.round2 : tree.round3;
  return layer === 1
    ? roundData.layer1
    : layer === 2
      ? roundData.layer2
      : layer === 3
        ? roundData.layer3
        : roundData.layer4;
}
